<ng-container *ngIf="valid; else invalidId">
  <div class="min-h-screen w-full flex flex-col items-center justify-center md:px-4 py-4 md:px-8 lg:px-12 overflow-y-auto" *ngIf="!loading; else loadingScreen">
    <div class="painel w-full bg-white shadow p-4 md:p-8">
      <img class="w-24 md:w-28 mx-auto" src="../../assets/images/logo.png" alt="Logo" />
      <span class="text-2xl font-semibold text-gray-800 mr-4 ml-2 block mb-2">
        {{ copy[locale]["details"] }}
      </span>
      <p class="text-black text-lg font-bold mr-2 ml-2 mb-2">
        {{ copy[locale]["status"] }}:
        <span class="invoice-badge status">
          {{ invoiceStatus[locale][invoice.status] }}
        </span>
      </p>
      <div class="flex flex-col sm:flex-row justify-between gap-4 my-2 ml-2 mr-2">
        <div class="flex-1">
          <p class="text-lg font-semibold text-neutral-700">
            {{ copy[locale]["resident"] }}: {{ invoice.contrato.locatario }}
          </p>
          <p class="mt-0.5 text-black font-bold text-sm">
            {{ copy[locale]["enterprise"] }}:
            <span class="text-neutral-400 text-sm">
              {{ invoice.contrato.empreendimento }}
            </span>
          </p>
          <p class="mt-0.5 text-black font-bold text-sm">
            {{ copy[locale]["unit"] }}:
            <span class="text-neutral-400 text-sm">
              {{ invoice.contrato.unidade }}
            </span>
          </p>
        </div>
        <div class="flex-1 sm:text-right text-left">
          <p class="mt-0.5 text-black font-bold text-sm">
            {{ copy[locale]["period"] }}:
            <span class="text-neutral-400 text-sm">
              {{ invoice.dataInicioCompetencia | date : "dd/MM/yyyy" }} -
              {{ invoice.dataFimCompetencia | date : "dd/MM/yyyy" }}
            </span>
          </p>
          <p class="mt-0.5 text-black font-bold text-sm">
            {{ copy[locale]["dueDate"] }}:
            <span class="text-neutral-400 text-sm">
              {{ invoice.dataVencimento | date : "dd/MM/yyyy" }}
            </span>
          </p>
        </div>
      </div>
      <hr class="my-2 border-gray-200" />

      <dl class="pb-2 mt-0.5 text-neutral-400 text-sm grid grid-cols-1 gap-2">
        <ng-container *ngFor="let info of invoice.itensFatura">
          <div *ngIf="info.valor > 0" class="flex items-center gap-2">
            <dt class="inline text-black font-bold">
              {{ dicionarioItensContrato[locale][info.nome] }}:
            </dt>
            <span class="flex-1 "></span>
            <span [class]="info.nome.includes('DESCONTO') ? 'text-danger' : 'text-success'">
              {{ info.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
            </span>
          </div>
        </ng-container>
      </dl>
      <div class="mt-2 text-black text-xl font-bold flex gap-1 justify-end">
        <span>
          {{ copy[locale]["total"] }}:
        </span>
        <span> {{ invoice.valorTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
      </div>
      <div class="mx-auto w-full">
        <div class="row ml-2" *ngIf="paymentError">
          <span class="text-red-400">{{ paymentError }}</span>
        </div>
        <div class="my-2 text-center" *ngIf="providerRedirect">
          <p [innerText]="
              providerRedirect === 'succeeded' && invoice.status !== 'PAGA'
                ? 'Pagamento efetuado, aguarde a confirmação'
                : ''
            "></p>
        </div>
        <div class="painel-botoes" *ngIf="
          !invoice.naoExibirOpcoesPagamento &&
          !providerRedirect &&
          (invoice.status === 'EMITIDA' ||
          invoice.status === 'PAGAMENTO_PENDENTE' ||
          invoice.status === 'EM_COMPENSACAO' ||
          invoice.status === 'VENCIDA')
        ">
          <app-pay-button
             *ngFor="let formaPagamentoItem of invoice.formasPagamento"
             [formaPagamento]="normalizeNomeFormaPagamento(formaPagamentoItem.tipo)"
             [locale]="locale"
             [disabled]="!!(loadingPayment ||(formaPagamento && formaPagamento.uuid === formaPagamentoItem.uuid && (customProviderPayment || loadingPayment)))"
             (onClick)="processPayment(formaPagamentoItem)"></app-pay-button>
        </div>

        <div *ngIf="loadingPayment" class="loading-payment-inline">
          <div class="loader"></div>
          <span class="text-neutral-600 text-base font-medium mt-2">
            {{ copy[locale]["loadingPayment"] || 'Processando pagamento...' }}
          </span>
        </div>
        <div *ngIf="!providerRedirect && !loadingPayment && formaPagamento && (cobranca || customProviderPayment)">
          <app-payment [locale]="locale" [cobranca]="cobranca" [invoice]="invoice"
            [formaPagamento]="formaPagamento"></app-payment>
        </div>

            <div class="flex justify-center mt-3 mb-6 w-full" *ngIf="showReceipt()">
      <button (click)="generateReceipt()" class="botao-recibo inline-block text-center w-full sm:w-auto mr-1">Recibo</button>
    </div>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #loadingScreen>
  <div class="loading-screen" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <span class="loading-text">Carregando...</span>
  </div>
</ng-template>

<ng-template #invalidId>
  <div class="invalid-id-screen" role="alert">
    <div class="invalid-id-content">
      <svg class="icon-error" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <circle cx="12" cy="12" r="10" stroke-width="2" class="text-red-200" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01"
          class="text-red-600" />
      </svg>
      <span class="invalid-text">Fatura inválida</span>
    </div>
  </div>
</ng-template>
